import styled from 'styled-components';

export const OTPContainer = styled.div`
  padding: 16px;
  width: 100dvw;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const OTPContent = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
  margin-top: 16px;
  background-color: #f9faf9;
`;

export const WrapperOTP = styled.div`
  width: 100%;
  height: 470px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const OTPStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  padding: 16px 0;
`;

export const OTPProvider = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OTPButton = styled.div`
  width: calc(100% - 32px);
  position: absolute;
  padding: 16px;
  bottom: 16px;
`;
export const ResetContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
  .underline {
    text-decoration: underline;
  }
`;
